import React from "react";
import { breakpointsInPx } from "lib/checkViewport";

import { ProgressBanner } from "../ProgressBanner/ProgressBanner";
import { thresholdCarouselWrapper } from "./ThresholdCarousel.css";

import type { ThresholdProgressResult } from "../thresholds";
import { CarouselModule } from "packages/ui-shared/components/CarouselModule";

export const ThresholdCarousel: React.FC<{
  progressBannerStyles?: string;
  thresholds: ThresholdProgressResult[];
}> = ({ progressBannerStyles = "", thresholds }) => {
  return (
    <CarouselModule
      carouselWrapperClassName={thresholdCarouselWrapper}
      tracking={undefined}
      carouselProps={{
        breakpoints: {
          [breakpointsInPx.sm]: {
            slidesPerView: 1,
            slidesPerGroup: 1
          },
          [breakpointsInPx.xs]: {
            slidesPerView: 1,
            slidesPerGroup: 1
          }
        },
        pagination: {
          clickable: true
        },
        scrollbar: false
      }}
    >
      {thresholds.map((threshold) => (
        <ProgressBanner
          key={threshold?.progressBanner?.copy}
          styles={progressBannerStyles}
          progressBannerCopy={threshold?.progressBanner?.copy || ""}
          percentProgress={threshold?.percentProgress || ""}
          type={threshold?.type}
        />
      ))}
    </CarouselModule>
  );
};
